import { render, staticRenderFns } from "./stores.vue?vue&type=template&id=48c090cc&scoped=true"
import script from "./stores.vue?vue&type=script&lang=js"
export * from "./stores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c090cc",
  null
  
)

export default component.exports